import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackInformations } from 'src/app/utils/interfaces/new/back-informations.interface';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/hypermed/infos';
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  async getBackendInfos(): Promise<BackInformations> {
    try {
      const res = await this._http.get(this.apiUri, this.httpOptions).toPromise();
      const infos = res.body as BackInformations;
      return infos;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
